/*@ngInject*/
const UserMediator = function (userRepository, userStateModel, userGroupsBrowserRepository, userGroupEditorRepository) {

    this.loadUserList = function (params) {
        return userRepository.loadUserList(params);
    };

    this.createNewUser = function (userType) {
        return userRepository.createNewUser(userType);
    };

    this.savePreviousUser = function (id, userType, formId) {
        userStateModel.savePreviousUser(id, userType, formId);
    };

    this.getPreviousUser = function () {
        return userStateModel.getPreviousUser();
    };

    this.saveViewState = function (stateName, stateModel) {
        userStateModel.saveViewState(stateName, stateModel);
    };

    this.restoreViewState = function (stateName, viewModel) {
        return userStateModel.restoreViewState(stateName, viewModel);
    };

    this.getPreviousViewState = function (stateName) {
        return userStateModel.getPreviousViewState(stateName);
    };

    this.hasPreviousUser = function () {
        return userStateModel.hasPreviousUser();
    };

    this.resetPreviousUser = function () {
        return userStateModel.resetPreviousUser();
    };

    this.loadUserActions = function (userType, userId) {
        return userRepository.loadUserActions(userType, userId);
    };

    this.loadUserById = function (userId) {
        return userRepository.loadUserById(userId);
    };

    this.closeUserPersistentConnection = function (userId) {
        return userRepository.closeUserPersistentConnection(userId);
    };

    this.upgradeForms = function (userId) {
        return userRepository.upgradeForms(userId);
    };

    this.getForms = function (userId) {
        return userRepository.getForms(userId);
    };

    this.loadUserGroupsActions = function () {
        return userGroupsBrowserRepository.loadUserGroupsActions();
    };

    this.getUserGroups = function (nameSearchString, requestParams) {
        return userGroupsBrowserRepository.getUserGroups(nameSearchString, requestParams);
    };

    this.loadUserGroupActions = function (userGroupId) {
        return userGroupEditorRepository.loadUserGroupActions(userGroupId);
    };

    this.loadUserGroupById = function (userGroupId) {
        return userGroupEditorRepository.loadUserGroupById(userGroupId);
    };

    this.loadCarrierUserRoles = function () {
        return userGroupEditorRepository.loadCarrierUserRoles();
    };

    this.createUserGroup =  function (userGroup) {
        return userGroupEditorRepository.createUserGroup(userGroup);
    }

    this.saveUserGroup =  function (userGroup) {
        return userGroupEditorRepository.saveUserGroup(userGroup);
    }

};

angular.module('umCore')
    .service('userMediator', UserMediator);
